module.exports = __webpack_public_path__ + "media/images/buttons/button-close-c485687057d308b8b5e030802914c458.svg";